var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFalcoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg1",
    width: 510.46552,
    height: 504.01169,
    viewBox: "0 0 510.46552 504.01169",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer2",
    transform: "matrix(1.1555044,0,0,1.1555044,-280.78757,27.732106)",
    clipPath: "none"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d88bc",
      fillOpacity: 1
    },
    d: "M 243,99.538646 466.83984,-24 577.07467,-19.536168 630.667,13.175135 575.08852,2.4391559 528.70931,-15.875456 l -62.19726,30.424042 -68.77716,23.61012 -4.50569,49.656938 -9.70543,62.028856 61.27117,51.47088 53.79476,54.79432 -5.40852,-40.26577 1.2928,-34.16468 28.45916,58.53043 24.13188,65.91933 -210.33211,106.05425 44.0509,-119.88727 z",
    id: "path1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0ea5e9",
      fillOpacity: 1
    },
    d: "m 630.667,13.175135 13.0427,50.977433 -35.50198,0.930806 -34.55661,-6.122606 -43.07804,14.956276 -43.8626,11.297134 7.10791,45.095472 0.6556,51.3696 1.84804,33.42074 2.26768,41.00971 -115.06593,-106.2652 14.21112,-111.685792 65.44732,-27.000627 65.5271,-27.033537 z",
    id: "path2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#0a7099",
      fillOpacity: 1
    },
    d: "m 643.7097,64.152568 -2.90649,11.03143 -24.07878,35.086702 -33.44085,35.38351 -36.21856,160.4748 -27.26741,-64.52474 -25.32363,-59.92502 -7.76351,-96.465072 41.05545,-12.397488 45.88519,-13.855922 z",
    id: "path3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6dc3e8",
      fillOpacity: 1
    },
    d: "m 559.60732,69.808263 c 2.11965,0.217772 5.95245,1.437299 7.79626,2.947207 1.84381,1.509908 1.69863,3.310128 1.65508,5.371733 -0.0436,2.061606 0.0145,4.384475 0.88562,6.794516 0.87111,2.410041 2.55518,4.907118 4.34094,6.663832 1.78576,1.756714 3.67308,2.772964 5.47335,3.411766 1.80027,0.638803 3.51339,0.900125 5.69114,0.783973 2.17775,-0.116151 4.82001,-0.609762 7.15746,-1.669607 2.33745,-1.059846 4.36995,-2.685845 6.11215,-4.340934 1.74219,-1.655088 3.19398,-3.339161 4.45708,-4.253809 1.26309,-0.914649 2.33741,-1.059828 3.26658,-0.740419 0.92918,0.319409 1.71314,1.103375 1.59698,2.540695 -0.11615,1.43732 -1.1324,3.52789 -3.0198,5.73468 -1.88739,2.206791 -4.64578,4.529649 -7.28812,6.329918 -2.64233,1.800266 -5.16845,3.077846 -8.31893,3.716646 -3.15048,0.6388 -6.92514,0.6388 -10.71442,-0.33394 -3.78928,-0.97274 -7.59297,-2.918133 -10.51115,-5.284626 -2.91817,-2.366493 -4.95068,-5.153928 -6.70739,-8.347963 -1.75672,-3.194035 -3.23754,-6.794472 -3.99249,-9.857837 -0.75494,-3.063366 -0.78398,-5.589476 -0.59524,-7.244555 0.18874,-1.655079 0.59524,-2.439049 2.7149,-2.221276 z",
    id: "path5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6dc3e8",
      fillOpacity: 1
    },
    d: "m 565.29845,65.409258 c -1.13242,4.23931 -2.26484,8.47862 -3.39726,12.71793",
    id: "path6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#6dc3e8",
      fillOpacity: 1
    },
    d: "m 640.80321,75.183998 39.87123,42.098722 4.09413,43.90299 -26.16777,41.81089 -4.32041,-29.83339 -14.89736,-10.8196 -56.09945,-16.6894 20.48802,-25.10091 10.01486,-12.26972 z",
    id: "path7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a7099",
      fillOpacity: 1
    },
    d: "m 636.87815,116.76299 c 3.14137,-2.32009 9.01346,-7.104 11.75445,-9.59862 2.741,-2.49462 2.3509,-2.69993 1.34483,-3.17217 -1.00608,-0.47224 -2.62806,-1.21137 -5.2767,-1.33083 -2.64864,-0.11946 -6.32376,0.38076 -8.96212,1.09938 -2.63835,0.71863 -4.2398,1.65561 -5.13294,3.19179 -0.89313,1.53618 -1.07791,3.67144 -0.79046,5.47826 0.28745,1.80681 1.04711,3.28507 1.64254,4.29114 0.59543,1.00606 1.02659,1.53987 1.4475,1.87865 0.4209,0.33878 0.83153,0.4825 3.9729,-1.8376 z",
    id: "path8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4fb6e3",
      fillOpacity: 1,
      strokeWidth: 0.865423
    },
    d: "m 603.7716,120.5533 39.9381,18.537 10.57069,34.07291 c -4.96588,-3.60661 -9.93157,-7.21307 -14.89736,-10.8196 -18.70019,-5.56325 -37.39963,-11.12626 -56.09945,-16.6894",
    id: "path14"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFalcoIcon);
export default __webpack_public_path__ + "static/media/FalcoIcon.a81a6da1729f80d29ffd07c190ed48bc.svg";
export { ForwardRef as ReactComponent };